export default {
  VERIFYING: 0,
  INCOMPLETE: 1,
  COMPLETE: 2,
};
